/** Kind of user to take. For frontend only. */
export enum UserKindEnum {
  /** Employee user (real person) */
  EMPLOYEE = 'EMPLOYEE',
  /** Bot user (technical user, for integrations) */
  BOT = 'BOT',
  /** Banned (softly deleted) user */
  BANNED = 'BANNED',
}
